import React from "react";
import BrandComponents from "../../../Masters/Brand/BrandComponents";

const SalesEnquiryIndexTable = () => {
  let header = [
    { label: "Id", field: "id" },
    { label: "Status", field: "status" },
    { label: "Enquiry Type", field: "enquirytype" },
    { label: "Enquiry Category", field: "enquirycategory" },
    { label: "Enquiry Date", field: "enquirydate" },
    { label: "Enquiry No.", field: "enquiryno" },
    { label: "Customer Name", field: "customername" },
  ];

  return (
    <BrandComponents
      header={header}
      tableTitle={"SALES ENQUIRY "}
      apiField={"enquiry"}
      addButton={"+ ADD"}
      createRoute={"/createSalesEnquiry"}
      updateRoute={"/viewSalesEnquiry"}
      viewRoute={"/viewSalesEnquiry"}
    />
  );
};

export default SalesEnquiryIndexTable;
